import { useMediaQuery } from "react-responsive"
import parse from "html-react-parser";

const BluePanelSection = (props) => {

    const isMobile = useMediaQuery({ maxWidth: 1280 })

    const { title, textArray } = props

    if (isMobile)
        return (
            <section className="flex w100 white-bkg">
                <section className="flex col pad-30 main-middle-section-2 blue-panel-section w100 us-blue-section">
                    <h2 className="us-middle-section-title ">{title}</h2>
                    {
                        textArray?.map((text, index) => {
                            return (<article key={index}>{parse(text)}</article>)
                        })
                    }
                </section>
            </section >
        )
    else
        return (
            <section className="flex w100 white-bkg">
                <section className="flex col pad-30 main-middle-section-2 blue-panel-section us-blue-section">
                    <h2 className="us-middle-section-title ">{title}</h2>
                    {
                        textArray?.map((text, index) => {
                            return (<article key={index}>{parse(text)}</article>)
                        })
                    }
                </section>
            </section >
        )

}

export default BluePanelSection